"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var _ = require("lodash");
exports.create = function (gridTop) {
    var rowsTops = [gridTop];
    var maxSpanByRow = {};
    var rowsTopsWedgeUnavailable = {};
    var isRowWithContent = function () { return !!maxSpanByRow[rowsTops.length]; };
    var rowsAPI = {
        count: function () { return rowsTops.length; },
        first: function () { return _.first(rowsTops); },
        last: function () { return _.last(rowsTops); },
        get: function (index) { return rowsTops[index]; },
        closeRow: function (rowBottom) {
            rowsTops.push(rowBottom);
        },
        getRowAbove: function (y) { return _.findLastIndex(rowsTops, function (value) { return value <= y; }); },
        isWedgePossible: function () { return !rowsTopsWedgeUnavailable[rowsAPI.last()]; },
        setNoWedge: function () {
            rowsTopsWedgeUnavailable[rowsAPI.last()] = true;
        },
        markRowWithContent: function () {
            maxSpanByRow[rowsAPI.count()] = maxSpanByRow[rowsAPI.count()] || 1;
        },
        createExtraRows: function (rowStart, rowBottom) {
            var currRowEnd = rowsAPI.count() + 1;
            var compSpan = currRowEnd - rowStart;
            var maxSpanInArea = _.max(_.times(compSpan, function (n) { return maxSpanByRow[rowStart + n] || 1; }));
            var rowsToAdd = _.max([isRowWithContent() ? 1 : 0, maxSpanInArea - compSpan + 1]);
            var spanWithExtraRows = compSpan + rowsToAdd;
            _.times(compSpan, function (n) { return maxSpanByRow[rowStart + n] = spanWithExtraRows; });
            _.times(rowsToAdd, function () {
                rowsAPI.closeRow(rowBottom);
                maxSpanByRow[rowsAPI.count()] = spanWithExtraRows;
            });
        }
    };
    return rowsAPI;
};
//# sourceMappingURL=rowsAPIFactory.js.map